export default __webpack_public_path__ + "static/media/photo--lg--4.cc8a65f1.jpg";